import { use } from 'react';

import { AuthContext, type AuthContextValue } from '@/features/auth/context';

/**
 * Lives apart from AuthProvider.tsx so that file exports only components.
 * Mixing a hook in there disables Vite fast refresh for the whole module.
 */
export function useAuth(): AuthContextValue {
  const context = use(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used inside <AuthProvider>.');
  }

  return context;
}
